import { shallowRef } from 'vue'
import { DEFAUT_STYLE_SECTIONS, type StyleSections } from './sections'

/**
 * Fond des en-têtes de section APPLIQUÉ, en état réactif : la teinte dépend de
 * la vue ouverte, qu'aucune feuille globale ne connaît.
 *
 * Écrite par `appliquer.ts` — et par lui seul — à chaque application de
 * l'apparence (cache, serveur, autre onglet, enregistrement). Lue par
 * `components/vues/FicheRecord.vue`.
 */
export const sectionsAppliquees = shallowRef<StyleSections>(DEFAUT_STYLE_SECTIONS)
